import { useEffect, useState } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    useDataProvider,
    useNotify,
    required,
    useCreate,
    useRedirect,
    useResourceContext,
    FileInput,
    FileField,
    TopToolbar
} from 'react-admin';
import { useQueryClient } from '@tanstack/react-query';
import BackButton from '../../Components/BackButton';
import { ErrorDetailsDialog } from '../../Components/ErrorDetailsDialog';

const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);

export const outboundProductBatchCreate = () => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const [customerTypeChoices, setCustomerTypeChoices] = useState([]);
    const [remainingStock, setRemainingStock] = useState(null);

    const redirect = useRedirect(); // 添加重定向钩子
    const resource = useResourceContext(); // 获取资源上下文
    const [create] = useCreate(); // 添加 useCreate 钩子

    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [importResult, setImportResult] = useState<{
        successCount: number;
        failCount: number;
        failedRecords: Array<any>;
    } | null>(null);

    const queryClient = useQueryClient();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [types, stock] = await Promise.all([
                    dataProvider.getSalesCustomers(),
                    dataProvider.getStockCount()
                ]);
                setCustomerTypeChoices(types);
                setRemainingStock(stock);
            } catch (error) {
                console.error("数据获取失败:", error);
                notify('数据加载失败', { type: 'error' });
            }
        };

        fetchData();
    }, []);

    // 处理表单提交
    const transformData = (data: any) => {
        const formData = new FormData();
        // 添加所有文本字段
        if (data.file && data.file.rawFile) {
            formData.append('file', data.file.rawFile);
        }
        formData.append('saleCustomerId', data.saleCustomerId);
        formData.append('logisticsNo', data.logisticsNo);
        formData.append('shippingAddress', data.shippingAddress);

        return formData;
    };

    const handleSubmit = (data: any) => {
        const formData = transformData(data);

        return create(
            'outboundProduct/BatchCreate',
            { data: formData },
            {
                onSuccess: (data) => {
                    if (data.failCount > 0) {
                        setErrorDialogOpen(true);
                    } else {
                        notify(`导入结果:成功${data.successCount}个，失败${data.failCount}`);
                        redirect('/outboundProduct', resource); // 成功时重定向
                    }
                    // queryClient.invalidateQueries({
                    //     queryKey: ['outboundProduct', 'getList']
                    // });

                    //redirect('/outboundProduct', resource); // 成功时重定向
                },
                onError: (error) => {
                    notify(`批量导入失败: ${error.message || '服务器错误'}`, { type: 'error' });
                }
            }
        );
    };


    const handleCloseErrorDialog = () => {
        setErrorDialogOpen(false);
    };

    return (
        <Create actions={<ActionsToolbar />} redirect="list" transform={transformData}>
            <SimpleForm
                onSubmit={handleSubmit}
                sx={{ width: { lg: '40%', xs: '100%' } }}
            >
                <div style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '1rem',
                    padding: '0.5rem',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px'
                }}>
                    剩余库存: {remainingStock ?? '加载中...'}
                </div>

                <SelectInput
                    choices={customerTypeChoices}
                    label="设备商家"
                    source="saleCustomerId"
                    validate={[required()]}
                    fullWidth
                />


                <FileInput
                    source="file"
                    label="excel文件"
                    accept=".xlsx, .xls" // 限制Excel文件类型
                    validate={[required()]}
                >
                    <FileField source="src" title="title" />
                </FileInput>

                <TextInput
                    label="收货地址"
                    source="shippingAddress"
                    fullWidth
                />

                <TextInput
                    label="物流单号"
                    source="logisticsNo"
                    fullWidth
                />
            </SimpleForm>
            <ErrorDetailsDialog
                open={errorDialogOpen}
                onClose={handleCloseErrorDialog}
                failedRecords={importResult?.failedRecords || []}
                successCount={importResult?.successCount || 0}
                failCount={importResult?.failCount || 0}
            />
        </Create>
    )
};